import { render, staticRenderFns } from "./NMBS.vue?vue&type=template&id=9d347b8c&"
import script from "./NMBS.vue?vue&type=script&lang=js&"
export * from "./NMBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports